<div class="flex items-center">
  <button
    type="button"
    class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-black"
    [class.bg-black]="checked"
    [class.bg-gray-200]="!checked"
    role="switch"
    [attr.aria-checked]="checked"
    [attr.aria-labelledby]="id"
    (click)="toggle()"
  >
    <span
      aria-hidden="true"
      class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-black transition duration-200 ease-in-out ml-[2px] mt-[2px]"
      [class.translate-x-5]="checked"
      [class.translate-x-0]="!checked"
    ></span>
  </button>
  <span class="ml-3 text-sm" [id]="id">
    <span class="font-medium text-gray-900 text-base">{{ text }}</span>
  </span>
</div>


